// frontend/src/components/FinanceReport/Accounting/allocations/PaymentSummary.jsx
import React from "react";
import { money } from "./helpers";

export default function PaymentSummary({
  currency,
  moneySum,
  allocationsSum,
  allocationsState, // 'empty' | 'complete' | 'incomplete'
  commissionsSum,
  remainingSum,
}) {
  const total = Number(moneySum || 0);
  const pct = (v) => (total > 0 ? Math.min(100, (Number(v) / total) * 100) : 0);

  const allocColor =
    allocationsState === "complete"
      ? "bg-emerald-500"
      : allocationsState === "incomplete"
      ? "bg-red-500"
      : "bg-slate-300";

  const allocText =
    allocationsState === "complete"
      ? "text-emerald-700"
      : allocationsState === "incomplete"
      ? "text-red-700"
      : "text-slate-500";

  const allocHint =
    allocationsState === "complete"
      ? "✓ всё распределено внутри"
      : allocationsState === "incomplete"
      ? "✕ есть нераспределённые назначения"
      : "назначений пока нет";

  const remainingPositive = Number(remainingSum) > 0.01;

  return (
    <section className="mb-5 rounded-2xl border border-slate-200 bg-white p-5">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">
            Сумма платежа
          </p>
          <p className="text-2xl font-bold text-slate-900">
            {money(total, currency)}
          </p>
        </div>
        <div className="text-right">
          <p className="text-xs uppercase tracking-wide text-slate-500">
            Не распределено
          </p>
          <p
            className={`text-xl font-bold ${
              remainingPositive ? "text-amber-700" : "text-emerald-700"
            }`}
          >
            {money(remainingSum, currency)}
          </p>
        </div>
      </div>

      {/* Один бар: allocations + commissions + остаток (автоматически фон) */}
      <div className="flex h-4 w-full overflow-hidden rounded-full bg-slate-100">
        <div
          className={`${allocColor} transition-all`}
          style={{ width: `${pct(allocationsSum)}%` }}
          title={`Оплата клиента поставщику: ${money(
            allocationsSum,
            currency
          )}`}
        />
        <div
          className="bg-blue-500 transition-all"
          style={{ width: `${pct(commissionsSum)}%` }}
          title={`Комиссии: ${money(commissionsSum, currency)}`}
        />
      </div>

      <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1.5 text-xs">
        <span className={`inline-flex items-center gap-1.5 ${allocText}`}>
          <span className={`h-2 w-2 rounded-full ${allocColor}`} />
          <span>
            <b>Оплата клиента поставщику</b> — {money(allocationsSum, currency)}
            <span className="ml-1 opacity-70">({allocHint})</span>
          </span>
        </span>
        <span className="inline-flex items-center gap-1.5 text-blue-700">
          <span className="h-2 w-2 rounded-full bg-blue-500" />
          <span>
            <b>Комиссионное вознаграждение</b> —{" "}
            {money(commissionsSum, currency)}
          </span>
        </span>
        <span
          className={`inline-flex items-center gap-1.5 ${
            remainingPositive ? "text-amber-700" : "text-emerald-700"
          }`}
        >
          <span className="h-2 w-2 rounded-full bg-slate-300" />
          <span>
            <b>Не распределено</b> — {money(remainingSum, currency)}
          </span>
        </span>
      </div>
    </section>
  );
}